



















import PageMixin from '@/mixins/page-mixin';
import CronjobServices from '@/services/cronjob';
import { mixins } from 'vue-class-component';
import { Vue, Component } from 'vue-property-decorator';
import JobFilter from '../../components/job-filter.vue';
import JobList from '../../components/job-record-list.vue';
@Component({
  components: { JobFilter, JobList }
})
export default class Job1 extends mixins(PageMixin) {
  bread = [{ name: '作业运行管理' }, { name: '系统运维作业' }];
  jobSrv = new CronjobServices();

  created() {
    this.getList();
  }

  list: any[] = [];
  async getList() {
    this.loading = true;
    let query = this.$route.query || {};
    let params = { ...this.filter, ...query, page: this.page, limit: this.limit, jobGroupName_eq: 'sys' };
    let res: any = await this.jobSrv.getRecordPage(params);
    this.list = res.records;
    this.total = res.total;
    this.loading = false;
  }
}
